import { render } from "./ToolsSidebar.vue?vue&type=template&id=c37ba436&scoped=true&ts=true"
import script from "./ToolsSidebar.vue?vue&type=script&lang=ts"
export * from "./ToolsSidebar.vue?vue&type=script&lang=ts"

import "./ToolsSidebar.vue?vue&type=style&index=0&id=c37ba436&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c37ba436"]])

export default __exports__